export interface FooterDocLink {
  fileName: string;
  label: string;
}

export const FOOTER_DOCS: readonly FooterDocLink[] = [
  {
    fileName: "1_Описание_функциональных_характеристик_ПО.docx",
    label: "Описание функциональных характеристик ПО",
  },
  {
    fileName: "2. Инструкция по установке.docx",
    label: "Инструкция по установке",
  },
  {
    fileName: "3. Инструкция по эксплуатации.docx",
    label: "Инструкция по эксплуатации",
  },
  {
    fileName: "4_Описание_ТС_хранения_исходного_текста_и_объектного_кода_ПО.docx",
    label: "Описание ТС хранения исходного текста и объектного кода ПО",
  },
  {
    fileName: "5_Описание_ТС_для_управления_лицензиями.docx",
    label: "Описание ТС для управления лицензиями",
  },
  {
    fileName: "6_Описание_процессов,_обеспечивающих_поддержание_ЖЦ.docx",
    label: "Описание процессов, обеспечивающих поддержание ЖЦ",
  },
  {
    fileName: "Оферта.docx",
    label: "Оферта",
  },
];

export const getFooterDocHref = (fileName: string): string =>
  `/files/${encodeURIComponent(fileName)}`;
